import { forwardRef } from "react";
import { Link } from "react-router-dom";

const themes = {
  primary: "bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground shadow-soft hover:shadow-hover",
  secondary: "bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground",
  outline: "border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground",
  outlineAccent: "border-2 border-primary text-primary bg-white hover:bg-accent hover:text-accent-foreground hover:border-accent",
  orange: "bg-orange text-orange-foreground hover:bg-destructive shadow-soft hover:shadow-hover",
} as const;

const sizes = {
  sm: "text-sm px-4 py-2",
  md: "text-base px-6 py-3",
  lg: "text-xl md:text-2xl px-6 md:px-8 py-3 md:py-4",
  xl: "text-xl md:text-3xl px-6 md:px-[30px] py-4",
} as const;

type ActionButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
  theme?: keyof typeof themes;
  size?: keyof typeof sizes;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(({
  children,
  onClick,
  to,
  theme = "primary",
  size = "md",
  className = "",
  ...buttonProps
}, ref) => {
  const base = `transition-colors duration-300 font-fredoka font-semibold rounded-xl inline-block text-center ${themes[theme]} ${sizes[size]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={base} onClick={onClick}>
        {children}
      </Link>
    );
  }

  return (
    <button ref={ref} className={base} onClick={onClick} {...buttonProps}>
      {children}
    </button>
  );
});

ActionButton.displayName = "ActionButton";

export default ActionButton;
